import React from 'react';
import cn from 'classnames';
import CounterBox from 'components/UI/CounterBox';
import { observer } from 'store';
import { getCountersHandlers, getInputControls } from '../utils';
import * as styles from './CounterGroup.module.scss';

function CounterGroup({ className, type, label, options }) {
  const { getValue, handleChange } = getInputControls(type, label);
  const { increment, decrement } = getCountersHandlers(handleChange);

  return (
    <div className={cn(styles.counterGroup, className)}>
      {options.map((item, i) => {
        const value = getValue(item);
        const labelId = `desktop-counter-label-${label}-${i}`;

        return (
          <div key={item} className={styles.counter}>
            <CounterBox
              theme="bigCircles"
              value={value}
              increment={() => increment(item, value)}
              decrement={() => decrement(item, value)}
              labelId={labelId}
            />
            <div id={labelId} className={styles.title}>
              {item}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default observer(CounterGroup);
